import * as ResourceApi from 'api/resources';
import React from 'react';
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {
    VideoHeadlineToolTip,
    VideoIntroToolTip,
    VideoEmbedCodeToolTip,
    VideoIDToolTip
} from 'components/break/tooltips/video-tool-tips';

export default {
    subSection: true,
    resource: false,
    hideIfResourceIsNoU: false,
    showSection: (formProxy) => {
        return formProxy.currentResource.resourceId.type === ResourceApi.Types.VideoStep
    },

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one step
            showField: (proxy) => (proxy.currentResource.type === 'VIDEO' && proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.video.headline',
                helpContent: <VideoHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.video.headline'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'topText',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'VIDEO'),
            props: {
              labelKey: 'editbreak.steps.video.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.video.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ],
              helpContent: <VideoIntroToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.video.intro_copy'}/></IntlProvider>
            }
        },
        {
          type: 'textarea',
          name: 'embedCode',
          required: true,
          showField: (proxy) => (proxy.currentResource.type === 'VIDEO'),
          props: {
            labelKey: 'editbreak.steps.video.embed_code',
            helpContent: <VideoEmbedCodeToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.video.embed_code'}/></IntlProvider>
          }
        },
        {
          type: 'text',
          name: 'videoId',
          required: true,
          showField: (proxy) => (proxy.currentResource.type === 'VIDEO'),
          props: {
            labelKey: 'editbreak.steps.video.video_id',
            helpContent: <VideoIDToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.video.video_id'}/></IntlProvider>
          }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentResource.type === 'VIDEO'),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/video.js